import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { useLang, track } from "@/context/LanguageContext";
import { IMAGES, CONTACT } from "@/data/config";

const grid = [
  IMAGES.equipRow,
  IMAGES.arch1,
  IMAGES.studioInterior,
  IMAGES.vanityWide,
  IMAGES.equipCarriage,
  IMAGES.arch2,
];

export function InstagramStrip() {
  const { t } = useLang();
  return (
    <section className="bg-petal" data-testid="instagram-strip">
      <div className="mx-auto max-w-[1600px] px-6 pb-4 pt-24 md:px-12 md:pt-32">
        <div className="flex flex-wrap items-end justify-between gap-6 border-b border-onyx/15 pb-8">
          <div>
            <p className="label text-terracotta">Instagram</p>
            <h2 className="mt-4 font-serif text-5xl leading-none md:text-6xl">{CONTACT.instagramHandle}</h2>
          </div>
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("social_click", { network: "instagram", source: "footer-strip" })}
            className="label group inline-flex items-center gap-3 border border-onyx px-8 py-4 transition-colors duration-500 hover:bg-onyx hover:text-petal"
            data-testid="instagram-follow"
          >
            <Instagram size={16} strokeWidth={1.4} />
            {t.footer.follow} {CONTACT.instagramHandle}
          </a>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {grid.map((src, i) => (
            <a
              key={i}
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("social_click", { network: "instagram", source: "grid" })}
              className="group relative block aspect-square overflow-hidden"
              data-testid={`instagram-tile-${i}`}
              aria-label={`Maison Core on Instagram`}
            >
              <img
                src={src}
                alt="Maison Core studio"
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
              />
              <motion.span className="absolute inset-0 flex items-center justify-center bg-onyx/0 text-petal opacity-0 transition-all duration-500 group-hover:bg-onyx/35 group-hover:opacity-100">
                <Instagram size={22} strokeWidth={1.4} />
              </motion.span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
